import { render, staticRenderFns } from "./ExtraVoyageSettings.vue?vue&type=template&id=36161345&scoped=true&"
import script from "./ExtraVoyageSettings.vue?vue&type=script&lang=js&"
export * from "./ExtraVoyageSettings.vue?vue&type=script&lang=js&"
import style0 from "./ExtraVoyageSettings.vue?vue&type=style&index=0&id=36161345&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36161345",
  null
  
)

export default component.exports